module.exports = __webpack_public_path__ + "img/video5.f92cfabc.jpg";